import React, { Component } from "react";
import FormControl from "@material-ui/core/FormControl";
import { Grid, Paper } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { connect } from "react-redux";
import { submit } from "redux-form";
import {
  GET_ONE,
  GET_LIST,
  fetchEnd,
  fetchStart,
  withDataProvider,
  SaveButton,
  SimpleForm,
  DisabledInput,
  Button,
  showNotification,
  CREATE,
  LongTextInput,
  BooleanInput,
  Loading
} from "react-admin";
import { Divider } from "@material-ui/core";
import { DateInput } from "../../components/fields/DateInput";
import IconCancel from "@material-ui/icons/Cancel";
import AddLineItemButton from "./AddLineItemButton";
import LoadingIndicator from "../../components/loadingIndicator";
import { formatNumber } from "../../utils/formating";

const apiUrl = process.env.BE_API_URL;

const cantidadTotal = items => {
  const val = items
    .map(({ quantity }) => quantity)
    .reduce((sum, i) => sum + i, 0);

  return formatNumber(val);
};

const styles = {
  detail: {
    root: {
      width: "80%",
      float: "right"
    },
    row: {
      backgroundColor: "rgb(239, 237, 237)"
    }
  }
};

const classes = {
  inline: {
    marginLeft: "5%",
    paddingLeft: "4%"
  },
  simpleForm: {
    width: "100%",
    display: "inline-table"
  },
  formControl: {
    display: "flex",
    width: "100%"
  },
  paper: {
    height: "100%"
  },
  button: {
    marginLeft: "2%",
    marginBottom: "2%"
  },
  grid: {
    display: "grid"
  },
  line: {
    "& div": { marginLeft: "3px" }
  },
  flex: {
    display: "flex"
  },
  noneDisplay: {
    display: "none"
  }
};
class OrderCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formId: new Date().getTime(),
      order: { customerId: null, customerName: null, detailLines: [] },
      loadingOrder: true,
      updateOrden: false
    };
  }

  // static propTypes = {
  //   customer: PropTypes.object
  // };

  async getData(customer) {
    const { dataProvider, dispatch } = this.props;
    const { id } = this.props.match.params;
    if (id) {
      await dataProvider(GET_ONE, `/orders/get/${id}`, null)
        .then(({ data }) => {
          if(data.dueDate){
            data.dueDate = data.dueDate.replace('Z','');
          }
          this.setState({
            order: data,
            loadingOrder: false
          });
        })
        .catch(error => {
          dispatch(showNotification(error.message, "error"));
        });
    } else {
      this.setState({
        order: {
          customerId: customer.customerId,
          customerName: customer.customer,
          detailLines: []
        },
        loadingOrder: false
      });
    }
  }

  async getProductList(customer) {
    const { dataProvider, dispatch } = this.props;
    await dataProvider(GET_LIST, "products/get/list", null)
      .then(({ data }) => {
        //filter the products that the customer can add to the order
        if (customer.productIds[0] && customer.productIds[0] !== "all") {
          data = data.filter(function(prod) {
            return this.indexOf(prod.productId) === 0;
          }, customer.productIds);
        }
        this.setState({ loadingListProduct: false, dataProduct: data });
      })
      .catch(error => {
        dispatch(showNotification(error.message, "error"));
      });
  }

  async componentDidMount() {
    const { customer } = this.props;
    if (customer.customer === "none") {
      window.location.href = window.location.origin + "/#/";
    } else {
      await this.getData(customer);
      await this.getProductList(customer);
    }
  }

  handleSaveClick = () => {
    const { submit } = this.props;
    const { formId } = this.state;
    // Trigger a submit of our custom quick create form
    // This is needed because our modal action buttons are oustide the form
    submit(formId);
  };

  handleCloseClick = () => {
    window.location.href = window.location.origin + "/#/orders";
  };

  addProductToOrder = productDTO => {
    const { order, dataProduct } = this.state;

    // case new
    if (!productDTO.lineNumber) {
      const productAdded = dataProduct.find(
        prod => prod.productId === productDTO.productId
      );
      //filtra los prods que ya se agregan a la tabla
      const data = dataProduct.filter(
        prod => prod.productId !== productDTO.productId
      );
      productDTO.lineNumber = order.detailLines.length;
      productDTO.productCode = productAdded.code;
      productDTO.description = productAdded.description;
      productDTO.unitPrice = productAdded.unitPrice || 0.00001;
      productDTO.discountPercentage = 0;
      order.detailLines.push(productDTO);
      delete productDTO.date;
      delete productDTO.dueDate;
      this.setState({ dataProduct: data, order });
    } else {
      const productEdited = order.detailLines.find(
        li => li.lineNumber === productDTO.lineNumber
      );
      productEdited.quantity = productDTO.quantity;
      this.setState({ order });
    }
  };

  handleSubmit = orderForm => {
    const { dataProvider, fetchStart, fetchEnd, showNotification } = this.props;

    orderForm.termId = "01"; // no hace falta mostrar este campo en la UI, pero en la API es requerido

    delete orderForm.customerName;
    delete orderForm.salesmenId;
    delete orderForm.salesmenName;
    delete orderForm.address;

    const { id } = this.props.match.params;
    this.setState({ updateOrden: true });
    if (id) {
      const APP_NAME = process.env.APP_NAME;
      const token = localStorage.getItem(APP_NAME + "token");
      //EDIT

      fetch(apiUrl + `/orders/update/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          token: token
        },
        body: JSON.stringify(orderForm)
      })
        .then(result => {
          showNotification(`Orden ${id} actualizada correctamente`, "info");
          this.setState({ updateOrden: false });
          window.location.href = window.location.origin + "/#/orders";
        })
        .catch(error => {
          showNotification(error.message, "error");
          this.setState({ updateOrden: false });
        });
    } else {
      //NEW
      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart();
      dataProvider(CREATE, "orders/new", { data: orderForm })
        .then(orden => {
          showNotification(
            `Orden ${orden.data.id} creada correctamente`,
            "info"
          );
          this.setState({ updateOrden: false });
          window.location.href = window.location.origin + "/#/orders";
        })
        .catch(error => {
          showNotification(error.message, "error");
          this.setState({ updateOrden: false });
        })
        .finally(() => {
          fetchEnd();
        });
    }
  };

  validateDate = values => {
    const errors = {};
    if (values.dueDate || values.date) {
      // debugger
      if (new Date(values.dueDate).setHours(0,0,0,0) < new Date(values.date).setHours(0,0,0,0)) {
        errors.dueDate = [
          "La Fecha de entrega no puede ser menor que la fecha de creación"
        ];
      }
    }
    return errors;
  };

  render() {
    const {
      loadingOrder,
      formId,
      order,
      dataProduct,
      updateOrden
    } = this.state;
    const { id } = this.props.match.params;

    return !loadingOrder
      ? <Grid container>
          <Paper style={classes.paper}>
            <SimpleForm
              record={order}
              // We override the redux-form name to avoid collision with the react-admin main form
              form={formId}
              onSubmit={this.handleSubmit}
              // We want no toolbar at all as we have our modal actions
              toolbar={null}
              style={classes.simpleForm}
              validate={this.validateDate}
            >
              <FormControl style={classes.formControl}>
                <Grid container spacing={3} style={classes.flex}>
                  <Grid item xs={3} style={classes.noneDisplay}>
                    <DisabledInput label="ID Cliente" source="customerId" />
                  </Grid>
                  <Grid item xs={3}>
                    <DisabledInput label="Cliente" source="customerName" />
                  </Grid>
                  <Grid item xs={3}>
                    <BooleanInput source="annulled" />
                  </Grid>
                  <Grid item xs={3}>
                    <BooleanInput source="archived" />
                  </Grid>
                  <Grid item xs={3}>
                    <BooleanInput source="locked" />
                  </Grid>
                  <Grid item xs={4}>
                    <DateInput
                      source="date"
                      label="Fecha"
                      defaultValue={new Date()}
                      options={{ format: "yyyy-MM-dd" }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <DateInput
                      source="dueDate"
                      label="Fecha prevista entrega"
                      defaultValue={new Date()}
                      options={{ format: "yyyy-MM-dd" }}
                    />
                  </Grid>
                  {id &&
                    <Grid item xs={12}>
                      <LongTextInput
                        source="nombreDireccion"
                        label="Dirección"
                      />
                    </Grid>}
                  <Grid item xs={12}>
                    <LongTextInput source="notes" label="Notas" />
                  </Grid>
                </Grid>
                <Divider />
                <Grid container>
                  <LoadingIndicator
                    isLoading={!dataProduct}
                    text="Buscando Productos"
                  />
                  {dataProduct &&
                    <AddLineItemButton
                      products={dataProduct}
                      addProductToOrder={this.addProductToOrder}
                    />}
                </Grid>
                <Grid item>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">ID</TableCell>
                        <TableCell align="left">Código</TableCell>
                        <TableCell align="left">Descripción</TableCell>
                        <TableCell align="left">Cantidad</TableCell>
                      </TableRow>
                    </TableHead>
                    {order.detailLines &&
                      order.detailLines.length &&
                      <TableBody>
                        {order.detailLines.map((row, key) =>
                          <TableRow key={key}>
                            <TableCell align="left">
                              {row.productId}
                            </TableCell>
                            <TableCell align="left">
                              {row.productCode}
                            </TableCell>
                            <TableCell align="left">
                              {row.description}
                            </TableCell>
                            <TableCell align="left">
                              {formatNumber(row.quantity)}
                            </TableCell>
                            <TableCell align="left">
                              <AddLineItemButton
                                selectedProd={row}
                                addProductToOrder={this.addProductToOrder}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell rowSpan={2} />
                          <TableCell rowSpan={2} />

                          <TableCell rowSpan={2} style={styles.detail.row}>
                            Cantidad Total
                          </TableCell>
                          <TableCell align="left" style={styles.detail.row}>
                            {cantidadTotal(order.detailLines)}
                          </TableCell>
                          <TableCell rowSpan={2} />
                        </TableRow>
                      </TableBody>}
                    {!order.detailLines && <div>Agrege un producto</div>}
                  </Table>
                </Grid>
              </FormControl>
              <Grid item>
                <SaveButton
                  onClick={this.handleSaveClick}
                  style={classes.button}
                  disabled={order.detailLines.length === 0}
                />

                <Button
                  label="ra.action.cancel"
                  onClick={this.handleCloseClick}
                  style={classes.button}
                >
                  <IconCancel />
                </Button>
              </Grid>
            </SimpleForm>
          </Paper>
          <LoadingIndicator
            isLoading={updateOrden}
            isFullScreen={true}
            text={
              this.props.match.params.id
                ? "Actualizando Orden"
                : "Creando orden"
            }
          />
        </Grid>
      : <Loading />;
  }
}

const OrderCreateWithProvider = withDataProvider(OrderCreate);

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  submit
};

export default connect(null, mapDispatchToProps)(OrderCreateWithProvider);
